/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerificationCode
 */
export interface VerificationCode {
    /**
     * 
     * @type {string}
     * @memberof VerificationCode
     */
    code: string;
}

/**
 * Check if a given object implements the VerificationCode interface.
 */
export function instanceOfVerificationCode(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function VerificationCodeFromJSON(json: any): VerificationCode {
    return VerificationCodeFromJSONTyped(json, false);
}

export function VerificationCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerificationCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function VerificationCodeToJSON(value?: VerificationCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

